module.exports = __webpack_public_path__ + "media/images/gallery/constellations/auriga/aur_gc-58ccc30104575e7aef84d10b71d66b64.gif";